import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { t } from "@shared/i18n";

export function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center p-6 text-center">
      <p className="text-7xl font-bold">404</p>
      <p className="mt-3 text-muted">{t("Cette page n'existe pas.")}</p>
      <Link to="/app" className="mt-6">
        <Button>{t("Retour à l'application")}</Button>
      </Link>
    </div>
  );
}
